export enum AnalyticsReportCreationSource {
  AskRedo = "ask_redo",
  Mcp = "mcp",
  Admin = "admin",
  PublicApi = "public_api",
}
